export const NAMESPACE = 'jbp-quality-indicator'

export const TRANSLATION_KEYS = {
  tag: {
    Low: `${NAMESPACE}-tag-low`,
    Moderate: `${NAMESPACE}-tag-moderate`,
    High: `${NAMESPACE}-tag-high`,
  },
}
